import * as angular from 'angular';
import { SpinnerModal } from './status-spinner/status-spinner.service';

import { UserAgentModalModule } from '../../shared/modals/user-agent/user-agent-modal.module';
import nvSharedModelsModule from '../models/nv.shared.models.module';
// tslint:disable-next-line:max-line-length
import { GradPlanningWizardTableModule } from './../../sdc/dashboards/grad-planning/grad-planning-wizard/grad-planning-wizard-table/grad-planning-wizard-table.module';
import { FindACourseModalModuleNew } from './credit-gap-course-picker/credit-gaps-course-picker-modal.module';
import { NoteConfirmDeletionModalModule } from './notes/notes-confirm-delete-modal/notes-confirm-delete-modal.module';
import { PlannedDiplomaOptionsModule } from './planned-diploma-options/planned-diploma-options.module';
import { StudentSupportModalModule } from './student-support/student-support-modal.module';

import { CreditGapFreeformCourseModal } from './credit-gap-freeform/credit-gap-freeform-course-modal.service';

export default angular
  .module('nv.shared.modals', [
    nvSharedModelsModule,
    GradPlanningWizardTableModule,
    PlannedDiplomaOptionsModule,
    StudentSupportModalModule,
    FindACourseModalModuleNew,
    'nv.shared.error-handling',
    'angulartics',
    NoteConfirmDeletionModalModule,
    UserAgentModalModule,
  ])
  .service('CreditGapFreeformCourseModal', CreditGapFreeformCourseModal)
  .service('SpinnerModal', SpinnerModal).name;
